import {
  Box
} from "@mui/material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { useState } from "react";
import {
  getLatLongPositionData,
  getFilterKeyData
} from "../../../../utility/helper";
import { useStyles } from "./styles";
import Geofence from "shared-component/geo-filter";
import CdadHeaderFilterTab from "../CdadHeaderFilterTab";
import CdadHeaderVehicleFilterComponent from "../CdadHeaderVehicleFilterComponent";
import CdadHeaderCampaignFilterComponent from "../CdadHeaderCampaignFilterComponent";
import CdadHeaderWarrentyClaimsFilterComponent from "../CdadHeaderWarrentyClaimsFilterComponent";
import CdadHeaderSignalsFilterComponent from "../CdadHeaderSignalsFilterComponent";
import CdadHeaderSamplingFilterComponent from "../CdadHeaderSamplingFilterComponent";
import { linkCdadMapFilterAttributes } from "assets/DataFile/headerPageData";

dayjs.extend(utc);

const CdadHeaderCenterFilterComponent = (props: any) => {

  const style = useStyles();
  const [currentTab, setCurrentTab] = useState<any>(0);
  const {
    vinList,
    canSignalData,
    FiftyOneSignalData,
    getUpdatedList,
    data,
    vinListFile,
    geoFilterCoordinates,
    geoFilterBondValue,
    onChangeLatLang,
    updateUnNestDataEnable,
    vehicleName,
    modelYear,
    dispatchModelType,
    plantName,
    lineOffDate, naOverseas, engineTypeCode, engineFamilyCode, powerTrainType, driveTrainCategory, transmissionType, transmissionModel, partNumber, partName,
    campaign,
    campaignInd,
    campaignTitle,
    mileage,
    vehicleWarrentyIndicator,
    vehicleHasClaimIndicator,
    claimedPartDescription,
    claimedPartNumber,
    t1Code,
    t2Code,
    fieldReportNumber,
    fieldReportStatus,
    fieldReportTitle,
    unNestedParamData,
    vinListFromFile,
    monthsInService,
    familyCd,
    odometerMin,
    odometerMax
  } = props;

  const updateCoordinates = (value: any) => {
    geoFilterCoordinates(value)
  };

  const updateBondValue = (value: string) => {
    geoFilterBondValue(value)
  }
  const filtersData = getFilterKeyData(linkCdadMapFilterAttributes?.mapView_data);

  const sortedCanSignalData = (canSignalData || []).filter((item: any) => item)?.sort();
  const sortedFiftyOneSignalData = (FiftyOneSignalData || []).filter((item: any) => item)?.sort();

  return (
    <div
      className={`secondFilterContainer ${style.mainWrap}`}
      style={{ display: "flex" }}
    >
      <div id="leftPanel" style={{ width: "60%" }}>
        <div style={{ border: "1px solid rgba(0, 0, 0, 0.1)", borderRadius: "8px", height: "100%", padding: "1rem" }}>
          <CdadHeaderFilterTab setCurrentTab={setCurrentTab} />
          {currentTab === 0 ?
            <CdadHeaderSignalsFilterComponent getUpdatedList={getUpdatedList} canSignalData={sortedCanSignalData} FiftyOneSignalData={sortedFiftyOneSignalData} data={data} updateUnNestDataEnable={updateUnNestDataEnable} unNestedParamData={unNestedParamData} />
            : currentTab === 1 ?
              <CdadHeaderVehicleFilterComponent getUpdatedList={getUpdatedList} vinListFile={(value: any) => vinListFile(value)} modelYear={modelYear} dispatchModelType={dispatchModelType} vehicleName={vehicleName} vinList={vinList}
                plantName={plantName}
                lineOffDate={lineOffDate}
                naOverseas={naOverseas}
                engineTypeCode={engineTypeCode}
                engineFamilyCode={engineFamilyCode}
                powerTrainType={powerTrainType}
                driveTrainCategory={driveTrainCategory}
                transmissionType={transmissionType}
                transmissionModel={transmissionModel}
                partNumber={partNumber}
                partName={partName}
                unNestedParamData={unNestedParamData}
                vinListFromFile={vinListFromFile}
                familyCd={familyCd}
                odometerMin={odometerMin}
                odometerMax={odometerMax}
              />
              : currentTab === 2 ?
                <CdadHeaderCampaignFilterComponent getUpdatedList={getUpdatedList} campaign={campaign} campaignInd={campaignInd} campaignTitle={campaignTitle} unNestedParamData={unNestedParamData} />
                :  currentTab === 3 ?
                <CdadHeaderWarrentyClaimsFilterComponent getUpdatedList={getUpdatedList} mileage={mileage} vehicleWarrentyIndicator={vehicleWarrentyIndicator} vehicleHasClaimIndicator={vehicleHasClaimIndicator}
                claimedPartDescription={claimedPartDescription} claimedPartNumber={claimedPartNumber} t1Code={t1Code} t2Code={t2Code} fieldReportNumber={fieldReportNumber} fieldReportStatus={fieldReportStatus}
                 fieldReportTitle={fieldReportTitle} monthsInService={monthsInService} unNestedParamData={unNestedParamData} />
                :
                <CdadHeaderSamplingFilterComponent getUpdatedList={getUpdatedList} unNestedParamData={unNestedParamData} />
          }
        </div>
      </div>
      <div className="rightPanel" style={{ width: "40%" }}>
        <Box
          height={"auto"}
          width={"auto"}
          my={4}
          display="flex"
          alignItems="center"
          gap={4}
          p={2}
          margin={0}
        >
          {false &&
            <div className={style.overlay}>
              <div className={style.loader}></div>
            </div>
          }
          {<Geofence updateCoordinates={updateCoordinates} updateBond={updateBondValue} onChangeLatLang={onChangeLatLang} mapData={linkCdadMapFilterAttributes?.mapView_data || []} mapDataPoints={getLatLongPositionData(linkCdadMapFilterAttributes?.mapView_data)} filtersData={filtersData} />}
        </Box>
      </div>
    </div>
  );
};

export default CdadHeaderCenterFilterComponent;
